import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Label = ({ children, className = "" }) => (
  <span
    className={`font-mono-accent text-xs uppercase tracking-[0.25em] text-[#2F3B2E]/70 ${className}`}
  >
    {children}
  </span>
);

export const CurrencyToggle = ({ currency, onChange, compact = false }) => (
  <div
    data-testid="currency-toggle"
    className={`inline-flex items-center rounded-full border border-[#2F3B2E]/20 bg-white ${compact ? "p-0.5" : "p-1"}`}
  >
    {[
      { id: "inr", label: "INR" },
      { id: "usd", label: "USD" },
    ].map((c) => (
      <button
        key={c.id}
        type="button"
        onClick={() => onChange(c.id)}
        data-testid={`currency-${c.id}`}
        className={`rounded-full ${compact ? "px-3 py-1.5 text-xs" : "px-4 py-2 text-sm"} font-medium transition-colors duration-200 ${
          currency === c.id
            ? "bg-[#2F3B2E] text-white"
            : "text-[#2F3B2E] hover:bg-[#2F3B2E]/10"
        }`}
      >
        {c.label}
      </button>
    ))}
  </div>
);
